// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.interface';

export const environment: Environment = {
    production: false,
    mapboxGlAccessToken:
        'pk.eyJ1IjoiYWRyb2l0Z3JvdXAtdm9sdW50ZWVyIiwiYSI6ImNsMHIydmx0azFqZ3UzZG50MTB2ZDg1Z3kifQ.Kjf1zwQ0TQZ3WX339XGEVw',
    apiBase: 'https://api.shelterukr.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
